import Vue from 'vue';
import Vuex from 'vuex';
import VueAxios from 'vue-axios';
import VueAuthenticate from 'vue-authenticate';
import { abilitiesPlugin } from '@casl/vue'
import ability from './ability'

import axios from 'axios';

Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.use(abilitiesPlugin, ability);
